import { createWebHashHistory, createRouter } from "vue-router";

import Error_404 from "@/views/Error_404/Error_404";

import AirdropPage from "@/views/Airdrop/AirdropPage";
// import HomeWrapper from "@/views/Home/HomeWrapper";
// import WalletPage from "@/views/Wallet/WalletPage";
// import MyPlansPage from "@/views/MyPlans/MyPlansPage";
// import MyCasesPage from "@/views/MyCases/MyCasesPage";
// import MyTeamPage from "@/views/MyTeam/MyTeamPage";
// import BinaryPage from "@/views/Binary/BinaryPage";
// import SettingsPage from "@/views/Settings/SettingsPage";

import { tokenValidate } from '@/auth'

const routes = [
  {
    path: "/404",
    name: "Error_404",
    component: Error_404,
  },
  // {
  //   path: "/",
  //   name: "Home",
  //   component: HomeWrapper,
  // },
  {
    path: "/",
    name: "AirdropPage",
    component: AirdropPage,
  },
  // {
  //   path: "/wallet",
  //   name: "Wallet",
  //   component: WalletPage,
  // },
  // {
  //   path: "/my-plans",
  //   name: "MyPlansPage",
  //   component: MyPlansPage,
  // },
  // {
  //   path: "/my-cases",
  //   name: "MyCasesPage",
  //   component: MyCasesPage,
  // },
  // {
  //   path: "/my-team",
  //   name: "MyTeamPage",
  //   component: MyTeamPage,
  // },
  // {
  //   path: "/binary",
  //   name: "BinaryPage",
  //   component: BinaryPage,
  // },
  // {
  //   path: "/settings",
  //   name: "SettingsPage",
  //   component: SettingsPage,
  // },
  { path: '/:catchAll(.*)', redirect: '/404', hidden: true }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

router.beforeEach((to, from, next)=> {
  tokenValidate().then(() => {
    next();
  }).catch(() => {
    next();
    
    if (to.path !== "/") {
      if (to.path !== '/airdrop') 
        router.push({name: 'Home'})
    } else if (JSON.parse(localStorage.getItem('mixerDevUserAuth')) === true && to.path === "/") {
      window.location.reload(true);
    }
  })
})

export default router;